	

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';


import App from './App';
import './App.css';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

const store = createStoreWithMiddleware(reducers);
window.store = store;


ReactDOM.render(

    <Provider store={store}>
      <App store={store} />
    </Provider>
  , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js